/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { IHealthCamp } from 'app/shared/model/health-camp.model';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';

export interface IBloodDonorFitness {
  id?: string;
  bloodType?: keyof typeof BloodGroup | null;
  hbLevel?: string | null;
  counselor?: string | null;
  phlebotonist?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  donorType?: IClinicalDictionary | null;
  vitals?: IVitals | null;
  atCamp?: IHealthCamp | null;
}

export const defaultValue: Readonly<IBloodDonorFitness> = {
  active: false,
};
